import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ServicesSection.css";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const servicesData = [
  {
    id: 1,
    title: "Endoscopic Ultrasound (EUS)",
    img: "https://i.ibb.co/Y72pg6Sc/Image-Placeholder.png",
    description:
      "A highly accurate test combining ultrasound with endoscopy to detect digestive and pancreatic diseases.",
  },
  {
    id: 2,
    title: "Irritable Bowel Syndrome (IBS)",
    img: "https://i.ibb.co/CKbPKvbx/Image-Placeholder-2.png",
    description:
      "Comprehensive treatment plans for irritable bowel syndrome (IBS).",
  },
  {
    id: 3,
    title: "Peptic Ulcer Disease",
    img: "https://i.ibb.co/YBsgM3W3/Container.png",
    description: "Effective care and monitoring for peptic ulcer disease.",
  },
  {
    id: 4,
    title: "Acute Gastroenteritis",
    img: "https://i.ibb.co/sJX1xtb7/Image-Placeholder-3.png",
    description:
      "Rapid diagnosis and treatment for acute gastroenteritis symptoms.",
  },
  {
    id: 5,
    title: "Hemorrhoids",
    img: "https://i.ibb.co/7NZrPq8G/Image-Placeholder-4.png",
    description: "Non-invasive and surgical treatments for hemorrhoids.",
  },
];
const ServicesSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const navigate = useNavigate();
  // Navigate to All Services and scroll to top
  // Navigate to Services page and scroll to top
const handleViewAll = () => {
  navigate("/services"); // Go to services page
  // Wait a tiny bit to ensure the new page renders, then scroll
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 50);
};
  // Intersection Observer for animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return (
    <section
      ref={sectionRef}
      className={`services-section ${isVisible ? "animate" : ""}`}>
      <h2 className="services-title">Restore Your Comfort:</h2>
      <h3 className="services-subtitle">Advanced Peptic Ulcer Care</h3>
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div
            key={service.id}
            className="service-card fade-up"
            style={{ transitionDelay: `${index * 0.2}s` }}>
            <img src={service.img} alt={service.title} className="service-img" />
            <div className="service-info">
              <p className="service-name">{service.title}</p>
              <button
                className="service-arrow"
                onClick={() => setSelectedService(service)}
              >
                →
              </button>
            </div>
          </div>
        ))}
        <div
          className="service-card view-all-card fade-up"
          style={{ transitionDelay: `${servicesData.length * 0.2}s` }}
        >
          <div className="view-all-content">
            <h4>View all Services</h4>
            <p>
              Quick access to emergency services, ensuring immediate care when
              you need it the most.
            </p>
            <button className="view-all-btn" onClick={handleViewAll}>
              View all <span>→</span>
            </button>
          </div>
        </div>
      </div>
      {/* ===== Modal Popup ===== */}
      {selectedService && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="modal-content modal-split"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setSelectedService(null)}
            >
              ×
            </button>
            {/* Left Image */}
            <div className="modal-left">
              <img
                src={selectedService.img}
                alt={selectedService.title}
                className="modal-image"
              />
            </div>
            {/* Right Info */}
            <div className="modal-right">
              <h2>{selectedService.title}</h2>
              <p>{selectedService.description}</p>
              <button
                className="book-btn"
                onClick={() =>
                  navigate(
                    `/Appointment?service=${encodeURIComponent(
                      selectedService.title
                    )}`
                  )
                }
              >
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default ServicesSection;